module.exports = __webpack_public_path__ + "assets/img/923034.4ee91969.jpg";